import { Selector } from '@casumo/dojo-react';
import classNames from 'classnames';
import { FC } from 'react';
import { TEST_ID } from '../../utils/constants';

type SuggestedAmountsProps = {
  amounts: number[];
  selectedAmount: string;
  currencySymbol: string;
  onSelect: (value: number) => void;
};

const PnpCashierSuggestionAmountContainer: FC<SuggestedAmountsProps> = ({
  amounts,
  selectedAmount,
  currencySymbol,
  onSelect,
}) => (
  <Selector name="pnp-suggested-amounts">
    {amounts.map((amount) => (
      <Selector.Radio
        key={amount}
        value={selectedAmount}
        name="pnp-suggested-amount"
        data-testid={TEST_ID.SELECT + 'pnp-amount-' + amount}
        onChange={() => onSelect(amount)}
        onClick={() => onSelect(amount)}
        className={classNames(
          'text-center py-3.5',
          'has-[:checked]:bg-purple-0',
          'has-[:checked]:text-purple-80',
          'focus-visible:ring-purple-80',
        )}
        checked={selectedAmount === String(amount)}
      >
        {currencySymbol}{amount}
      </Selector.Radio>
    ))}
  </Selector>
);

export default PnpCashierSuggestionAmountContainer;
